import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 3rem;
  .profile-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    border-radius: 50%;
    img {
      width: 150px;
      height: 150px;
      margin-bottom: 1rem;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .file-input {
    display: none;
  }
  .password {
    display: flex;
    background: var(--clr-grey-10);
    border-radius: var(--radius);
  }
  .togglebtn {
    background: #D3A143;
    display: inline-block;
    min-width: min-content;
    margin: 0.5rem;
  }
  form {
    min-width: 300px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .form-control {
      width: 100%;
      margin-bottom: 1.25rem;
    }
    .input {
      width: 100%;
      padding: 0.5rem;
      background: var(--clr-grey-10);
      border-radius: var(--radius);
      border-color: transparent;
      letter-spacing: var(--spacing);
      text-align: center;
    }
    .input::placeholder {
      text-transform: capitalize;
    }
    .submit-btn {
      width: 100%;
    }
  }
  .seperator {
    position: relative;
    min-width: 300px;
    max-width: 400px;
    display: flex;
    align-items: center;
    margin: 3rem 0;
    span {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      padding: 0.5rem;
      background: white;
      font-weight: 500;
    }
    hr {
      width: 100%;
    }
  }
  .btn-container {
    min-width: 300px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .link {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
    }
  }
`;


const AddressWrapper = styled.section`
  display: flex;
  justify-content: center;

  @media (max-width: 700px) {
    flex-direction: column-reverse;
    align-items: center;
  }

  .addressdiv {
    display: flex;
    justify-content: space-around;
  }

  div {
    min-width: 300px;
  }
  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.25rem;
  }
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .form-control {
      margin-bottom: 1.25rem;
      h5 {
        margin-bottom: 0.5rem;
      }
    }
    .input {
      width: 100%;
      padding: 0.5rem;
      background: var(--clr-grey-10);
      border-radius: var(--radius);
      border-color: transparent;
      letter-spacing: var(--spacing);
    }
    .input::placeholder {
      text-transform: capitalize;
    }
    .sort-input {
      max-width: 300px;
      border-color: transparent;
      font-size: 1rem;
      text-transform: capitalize;
      padding: 0.25rem 0.5rem;
    }
    .links {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .link {
      font-size: smaller;
      color: var(--clr-primary-1);
      text-transform: capitalize;
    }
    .shipping-btn {
      margin-top: 1.25rem;
      width: 100%;
    }
  }

  .PaymentDiv {
    margin-left: 50px;
    max-width: 300px;
  }
  .paymentDiv p {
    display: inline-block;
  }

  @media (max-width: 700px) {
    .PaymentDiv {
      margin-left: 0px;
      margin-bottom: 30px;
    }
  }
`;

const WrapperDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .empty {
    text-align: center;
  }
`;

export { Wrapper, AddressWrapper, WrapperDiv };

